import { render, staticRenderFns } from "./setting-advanced-index.vue?vue&type=template&id=52c1ee54&"
import script from "./setting-advanced-index.vue?vue&type=script&lang=js&"
export * from "./setting-advanced-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports